import { type z } from 'zod'
import { type Control, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'

import { Badge, Button } from '@olino/design-system'

type EditableInfoProps<TData extends { [x: string]: any }> = {
  schema: z.ZodType<TData>
  value: TData
  displayValue: (value: TData) => string

  label: string
}

export const SummaryProperty = <TData extends { [x: string]: any }>({
  schema,
  value,
  displayValue,

  label,
}: EditableInfoProps<TData>) => {
  const { control, handleSubmit } = useForm<TData>({
    resolver: zodResolver(schema),
    // @ts-expect-error Can't be bothered to fix this
    defaultValues: value,
  })

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
      <div className="font-medium">{label}</div>

      <div className="flex items-center gap-3 md:col-span-2">
        <Badge className="normal-case">{displayValue(value)}</Badge>
      </div>
    </div>
  )
}
